import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

export default {
	get(): boolean {
		return isExperimentEnabled('rovo_fps_remove_linked_user_hydration');
	},
};
